import React from "react";

interface Props {}

const Contents: React.FC<Props> = (props) => {
  return (
    <div className="Contents container padding100" id="contents">
      <h6>AL-MARE</h6>
      <h1>CONTENTS</h1>
      <div className="row">
        <div className=" col-12 col-lg-4  pb-3 pb-lg-0">
          <img src="content1.jpg" alt="" className="w-100" />
        </div>
        <div className="col-12 col-lg-8">
          <p>
            Al-Mare Beach Bar is the perfect place to combine relaxation and
            entertainment. Within the bar area, there is a freshwater pool. The
            bar is located on the hotel private beach, fully equipped with sun
            umbrellas and sun beds. The bar is one of the most beautiful bars in
            the region offering all types of quality coffee, alcoholic and soft
            drinks, as well as light snacks.
            <br />
            <br />
            Al-Mare a-la–carte restaurant will meet each guest's taste offering
            traditional Greek meals menu, but also European meals menu.
            <br />
            The reception desk is open from 7:00 to 22:00 every day. We offer
            organization of daily excursions services, transfer to and from the
            Thessaloniki airport, photocopying services, fax services, etc.
            <br />
            <br />
            The Al-Mare Team is capable of organizing any type of celebrations /
            events (children's birthdays, private receptions, parties). The
            Al-Mare Bar and the magnificent sandy beach are an ideal place for
            your wedding or private dinner by candlelight, accompanied by the
            most wonderful sunset ever.
            <br />
            <br />
            The Al-Mare team is at your disposal at all times!
          </p>
        </div>
      </div>
        <div className="row py-4">
          <div className=" col-12 col-lg-4 pb-3 pb-lg-0">
            <img src="content3.jpg" alt="" className="w-100" />
          </div>
          <div className="col-12 col-lg-8">
            <img src="content2.jpg" alt="" className="w-100" />
          </div>
        </div>
    </div>
  );
};

export default Contents;
